export const AppSecret = "web_v3a035nwsg";
